'use client'

import { useViewportSize } from '@mantine/hooks'
import { theme } from '@qr-front/ui'
import { cn, pxStringToNumber } from '@qr-front/ui/utils'
import { useIsKeyboardOpen } from 'hooks/useVisualViewport'
import { ReactNode } from 'react'

import { useCurrGeneratorStep } from '../../hooks'

export const GeneratorFooterContainer = ({
	children,
}: {
	children: ReactNode
}) => {
	const { width } = useViewportSize()

	const isDesktop = width >= pxStringToNumber(theme.screens.desktop)

	const currStep = useCurrGeneratorStep()
	const isKeyboardOpen = useIsKeyboardOpen()

	if (currStep === 'type' && !isDesktop) {
		return null
	}

	const isInlineOnMobile = isKeyboardOpen && !isDesktop

	return (
		<footer
			className={cn(
				'bg-white shadow',
				!isInlineOnMobile && 'sticky bottom-0 z-10',
			)}
			style={
				!isInlineOnMobile
					? { bottom: 'calc(0px - env(safe-area-inset-bottom, 0px))' }
					: undefined
			}
		>
			{children}
		</footer>
	)
}
